exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lgpd-campaign-text[data-v-445522f6] {\n  text-align: left;\n  word-break: break-word;\n}\n", ""]);

// exports
